var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSccMedium({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 2,
    fill: "#FA7B17"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8803 14.5885H9.4941L9.38619 5.91439H10.9965L10.8803 14.5885ZM9.32809 17.228C9.32809 16.979 9.40279 16.7715 9.5522 16.6055C9.70715 16.434 9.93403 16.3482 10.2329 16.3482C10.5317 16.3482 10.7586 16.434 10.9135 16.6055C11.0684 16.7715 11.1459 16.979 11.1459 17.228C11.1459 17.4771 11.0684 17.6846 10.9135 17.8506C10.7586 18.0111 10.5317 18.0913 10.2329 18.0913C9.93403 18.0913 9.70715 18.0111 9.5522 17.8506C9.40279 17.6846 9.32809 17.4771 9.32809 17.228ZM15.263 14.5885H13.8768L13.7689 5.91439H15.3792L15.263 14.5885ZM13.7108 17.228C13.7108 16.979 13.7855 16.7715 13.9349 16.6055C14.0898 16.434 14.3167 16.3482 14.6155 16.3482C14.9144 16.3482 15.1412 16.434 15.2962 16.6055C15.4511 16.7715 15.5286 16.979 15.5286 17.228C15.5286 17.4771 15.4511 17.6846 15.2962 17.8506C15.1412 18.0111 14.9144 18.0913 14.6155 18.0913C14.3167 18.0913 14.0898 18.0111 13.9349 17.8506C13.7855 17.6846 13.7108 17.4771 13.7108 17.228Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSccMedium);
export default __webpack_public_path__ + "static/media/scc_Medium.bc4a4cd5d6c0af0fc97281616835b878.svg";
export { ForwardRef as ReactComponent };